export default "__VITE_ASSET__3f366a73__"